export default [
  {
    path: '/customer',
    name: 'customer',
    meta: {
      login: true
    }
  },
  { path: '/customer/FeedbackControl', name: 'FeedbackControl', component: resolve => require(['@/views/customer/FeedbackControl'], resolve) },
  { path: '/customer/ApplyReport', name: 'ApplyReport', component: resolve => require(['@/views/customer/ApplyReport'], resolve) },
  { path: '/customer/DownloadReport', name: 'DownloadReport', component: resolve => require(['@/views/customer/DownloadReport'], resolve) },
  {
    path: '/customer/userTrialApplication',
    name: 'UserTrialApplication',
    component: resolve => require(['@/views/customer/UserTrialApplication'], resolve)
  },
  {
    path: '/customer/WorkstationIntroConfig',
    name: 'ProductPresentationSetting',
    component: resolve => require(['@/views/customer/ProductPresentationSetting'], resolve)
  },
  { path: '/customer/bannerConfig', name: 'bannerConfig', component: resolve => require(['@/views/customer/bannerConfig'], resolve) },
  { path: '/customer/portNoticeConfig', name: 'portNoticeConfig', component: resolve => require(['@/views/customer/portNoticeConfig'], resolve) },
  { path: '/customer/userList', name: 'userList', component: resolve => require(['@/views/customer/userList'], resolve) },
  { path: '/customer/userListChannel', name: 'userListChannel', component: resolve => require(['@/views/customer/userListChannel'], resolve) },
  { path: '/customer/potentialUserList', name: 'potentialUserList', component: resolve => require(['@/views/customer/potentialUserList'], resolve) },
  { path: '/customer/companyUserApplyList', name: 'companyUserApplyList', component: resolve => require(['@/views/customer/companyUserApplyList'], resolve) },
  {
    path: '/customer/userQueryStatistic',
    name: 'userQueryStatistic',
    component: resolve => require(['@/views/customer/userQueryStatistic'], resolve)
  }
]



// WEBPACK FOOTER //
// ./src/config/router/customer.js